import { useCallback } from 'react'
import { useGasPrice } from 'state/user/hooks'
import { publicClient } from 'utils/wagmi'
import {
  Abi,
  Account,
  Address,
  CallParameters,
  Chain,
  GetFunctionArgs,
  InferFunctionName,
  WriteContractParameters,
} from 'viem'
import { EstimateContractGasParameters } from 'viem/dist/types/actions/public/estimateContractGas'
import { useWalletClient } from 'wagmi'
import { SendTransactionResult } from 'wagmi/actions'
import { calculateGasMargin } from 'utils'
import { browserCache } from 'utils/Cache'
import { useActiveChainId } from './useActiveChainId'

export function useCallWithGasPrice() {
  const gasPrice = useGasPrice()
  const { chainId } = useActiveChainId()
  const { data: walletClient } = useWalletClient()

  // const callWithGasPrice = useCallback(
  //   async <
  //     TAbi extends Abi | unknown[],
  //     TFunctionName extends string = string,
  //     _FunctionName = InferFunctionName<TAbi, TFunctionName>,
  //     Args = TFunctionName extends string
  //       ? GetFunctionArgs<TAbi, TFunctionName>['args']
  //       : _FunctionName extends string
  //       ? GetFunctionArgs<TAbi, _FunctionName>['args']
  //       : never,
  //   >(
  //     contract: { abi: TAbi; account: Account; chain: Chain; address: Address },
  //     methodName: InferFunctionName<TAbi, TFunctionName>,
  //     methodArgs?: Args extends never ? undefined : Args,
  //     overrides?: Omit<CallParameters, 'chain' | 'to' | 'data'>,
  //   ): Promise<SendTransactionResult> => {
  //     const res = await walletClient.writeContract({
  //       abi: contract.abi,
  //       address: contract.address,
  //       functionName: methodName,
  //       args: methodArgs,
  //       account: walletClient.account,
  //       gasPrice,
  //       ...overrides,
  //     } as any) // TODO: fix types

  //     const hash = res

  //     return {
  //       hash,
  //     }
  //   },
  //   [gasPrice, walletClient],
  // )

  const callWithGasPriceWithSimulate = useCallback(
    async <
      TAbi extends Abi | unknown[],
      TFunctionName extends string = string,
      _FunctionName = InferFunctionName<TAbi, TFunctionName>,
      Args = TFunctionName extends string
        ? GetFunctionArgs<TAbi, TFunctionName>['args']
        : _FunctionName extends string
        ? GetFunctionArgs<TAbi, _FunctionName>['args']
        : never,
    >(
      contract: { abi: TAbi; account: Account; chain: Chain; address: Address },
      methodName: InferFunctionName<TAbi, TFunctionName>,
      methodArgs?: Args extends never ? undefined : Args,
      overrides?: Omit<CallParameters, 'chain' | 'to' | 'data'>,
    ): Promise<SendTransactionResult> => {
      /* const { chain, transport } = walletClient
      const network = {
        chainId: chain.id,
        name: chain.name,
        ensAddress: chain.contracts?.ensRegistry?.address,
      }
      const provider = new BrowserProvider(transport as any, network)
      const etherContract = new Contract(contract.address, contract.abi as any, provider)




      let gas

      const args = [methodArgs == undefined ? undefined : methodArgs, {
        from: walletClient.account.address,
        gasPrice,
        value: 0n,
        ...{
          ...overrides,
          gas: undefined,
        }
      }].filter(it=> it)
        .flatMap(it=> {

          if (Array.isArray(it)){
            return it
          }
          return  [it]


        })
      console.log(
        methodName,methodArgs, {
          from: walletClient.account.address,
          gasPrice,
          value: 0n,
          ...{
            ...overrides,
            gas: undefined,
          }
        },args
      )
      try {
        gas =  await etherContract[methodName].estimateGas(...args)
      }catch (e) {
        console.error(e)
        throw e
      } */

      try {
        const gas = await publicClient({ chainId }).estimateContractGas({
          abi: contract.abi,
          address: contract.address,
          account: walletClient.account,
          functionName: methodName,
          args: methodArgs,
          gasPrice,
          value: 0n,
          ...{
            ...overrides,
            gas: undefined,
          },
        } as unknown as EstimateContractGasParameters)

        const res = await walletClient.writeContract({
          abi: contract.abi,
          address: contract.address,
          account: walletClient.account,
          functionName: methodName,
          args: methodArgs,
          gasPrice,
          gas: calculateGasMargin(gas),
          value: 0n,
          ...overrides,
        } as unknown as WriteContractParameters)

        const hash = res

        return {
          hash,
        }
      } catch (e) {
        const key = `getBytecode${chainId}_${walletClient.account.address}`
        let byteCode = browserCache.get(key)

        if (byteCode === undefined || byteCode === null) {
          const saveByteCode = await publicClient({ chainId }).getBytecode({
            address: walletClient.account.address,
          })
          browserCache.put(key, saveByteCode === undefined ? 'none' : saveByteCode, 100 * 365 * 24 * 60 * 60 * 1000)
          byteCode = browserCache.get(key)
        }

        if (byteCode !== 'none') {
          const res = await walletClient.writeContract({
            abi: contract.abi,
            address: contract.address,
            account: walletClient.account,
            functionName: methodName,
            args: methodArgs,
            gasPrice,
            // gas: calculateGasMargin(gas),
            value: 0n,
            ...overrides,
          } as unknown as WriteContractParameters)

          const hash = res

          return {
            hash,
          }
        }
        throw e
      }
    },
    [chainId, gasPrice, walletClient],
  )

  return { callWithGasPrice: callWithGasPriceWithSimulate }
}
